import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { DmaMap } from "../../components/dma-map";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { MaterialHero } from "../../components/static-page-components/material-hero";
import { HashLink } from "react-router-hash-link";
import { Pages } from "../../utils";
import EastIcon from "@mui/icons-material/East";
import setTheToneImageMobile from "../../assets/territories/set-the-tone_m.jpg";
import { HowItWorksBlock } from "../landing-page/how-it-works-block";
import { Link } from "react-router";
import { SplitScreenBlock } from "../../components/static-page-components/split-screen-block";
import split2Image from "../../assets/territories/Max_ROI_m.jpg";
import split1Image from "../../assets/territories/The_Formula_m.jpg";
import "./styles.scss";
import { Accordion } from "../../components/accordion";
import lottieAnimation from "../../assets/territories/lottie.json";
import Lottie from "react-lottie";
import { Funnel } from "./funnel";
import homeownersFunnelImage from "../../assets/territories/Homeowners_d.png";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";

export const TerritoriesPage = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="page territories-page">
      <MaterialHero title="TERRITORIES & MARKETING" />
      <LandingPageSection>
        <Grid2 container>
          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Typography
              variant="h4"
              component="h2"
              className="text-pink"
              mb="16px"
            >
              Set the Tone
            </Typography>
            <Typography variant="h5" component="h3" mb="16px">
              Territory-Based Marketing That Works for You
            </Typography>
            <Typography variant="body1" mb="28px">
              We help interior designers grow with exclusive access to
              high-potential markets, defined by household reach and backed by
              real marketing data.
            </Typography>
            <Button
              variant="outlined"
              component={HashLink}
              to={`${Pages.TERRITORIES}#map`}
              endIcon={<EastIcon />}
            >
              See Your Territory Potential
            </Button>
          </Grid2>
          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <img
              src={setTheToneImageMobile}
              alt="set the tone graphic"
              className="full-width-image"
            />
          </Grid2>
        </Grid2>
      </LandingPageSection>

      <LandingPageSection className="green-section">
        <Typography
          variant={"display2" as any}
          component="h2"
          className="text-white text-center"
          mb="16px"
        >
          How It Works
        </Typography>
        <Typography
          variant="h5"
          fontWeight={400}
          component="p"
          className="text-white text-center"
          mb="40px"
        >
          How Our Regional Marketing Works.
        </Typography>

        <Grid2 container spacing="40px" mb="40px">
          <HowItWorksBlock
            size={{
              xs: 12,
              md: 4,
            }}
            number={1}
            title="DEFINED BY DMA"
            description="We organize the U.S. into media markets to  target affluent homeowners precisely."
          />
          <HowItWorksBlock
            size={{
              xs: 12,
              md: 4,
            }}
            number={2}
            title="LIMIT NUMBER OF DESIGNERS"
            description="Memberships per territory are calculated based on our funnel. Helping to ensure every designer gets their share of qualified leads."
          />
          <HowItWorksBlock
            size={{
              xs: 12,
              md: 4,
            }}
            number={3}
            title="LEAD GENERATION FUNNEL"
            description="Our funnel targets high-intent homeowners and converts them into quality leads just for you."
          />
        </Grid2>
      </LandingPageSection>

      <Box
        pt={2}
        pb={10}
        component="section"
        className="green-section funnel-section"
        sx={{
          background: "#00a06d",
        }}
      >
        <Box className="site-wrapper" mb="40px">
          <Typography
            variant="body1"
            fontWeight={600}
            className="text-white text-center"
          >
            THE HOME DESIGN GUILD LEAD GENERATION FUNNEL
          </Typography>
          <Typography variant="body1" className="text-white text-center">
            Below is an example of the HDG funnel works to output the number of
            designers per territory.
          </Typography>
        </Box>
        <Box
          mx="auto"
          maxWidth={{
            xs: "311px",
            md: "280px",
          }}
          mb="40px"
        >
          <img
            src={homeownersFunnelImage}
            alt="homeowners funnel"
            className="full-width-image"
          />
        </Box>
        <Box>
          <Funnel />
        </Box>

        <Box
          sx={{
            maxWidth: "628px",
            background: "#D6EDFF",
            borderRadius: "16px",
          }}
          p={1.5}
          mx="auto"
          mt="40px"
        >
          <Stack direction={"row"} spacing={1}>
            <InfoOutlineIcon
              sx={{
                color: "#3B82F6",
              }}
            />
            <Box>
              <Typography color="#3B82F6" variant="body1" fontWeight={600}>
                Total # of Jobs
              </Typography>
              <Typography variant="body1">
                We calculate the number of Designers per Territory by the total
                number of Estimated Jobs we get at the end of this funnel
                process. Not leads but jobs, this ensures we are providing a
                maximum return opportunity for each of our designers and not
                over-saturating our memberships.
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Box>

      <LandingPageSection>
        <Typography
          variant={"display2" as any}
          component="h2"
          className="text-center text-pink"
          mb="16px"
        >
          FIND YOUR TERRITORY
        </Typography>
        <Typography variant="h5" className="text-center" mb="16px">
          Your Local Advantage Starts Here
        </Typography>
        <Typography variant="body1" className="text-center contain-text">
          Marketing dollars go further when we target by region. Explore your
          Designated Media Area to see available spots and lead potential.
        </Typography>
      </LandingPageSection>

      <div id="map">
        <DmaMap />
      </div>

      <LandingPageSection>
        <Typography
          variant={"display2" as any}
          component="h2"
          className="text-center text-pink"
          mb="16px"
        >
          WHY LIMIT DESIGNERS?
        </Typography>
        <Typography variant="h5" className="text-center" mb="16px">
          Exclusivity That Pays Off
        </Typography>
        <Typography
          variant="body1"
          className="text-center contain-text"
          mb="60px"
        >
          Unlike other platforms that flood markets with professionals, we cap
          designer spots per territory to maximize your return on investment.
          Our model ensures you get matched with serious homeowners — not just a
          name in a directory.
        </Typography>
        <Stack
          direction={{
            xs: "column",
            md: "row",
          }}
          spacing="24px"
          sx={{
            maxWidth: "618px",
            mx: "auto",
          }}
        >
          <Button
            variant="outlined"
            component={HashLink}
            to={Pages.SIGNUP}
            endIcon={<EastIcon />}
            sx={{ width: "100%" }}
          >
            Create an Account
          </Button>
          <Button
            variant="contained"
            component={HashLink}
            to={Pages.LOGIN}
            endIcon={<EastIcon />}
            sx={{ width: "100%" }}
          >
            Log in
          </Button>
        </Stack>
      </LandingPageSection>

      <LandingPageSection sx={{ pt: 0 }}>
        <Lottie options={defaultOptions} height={400} width={400} />
      </LandingPageSection>

      <LandingPageSection>
        <Typography
          variant={"display2" as any}
          component="h2"
          className="text-center text-pink"
          mb="16px"
        >
          THE MATH BEHIND IT
        </Typography>
        <Typography variant="h5" className="text-center" mb="16px">
          We Use Data to Deliver Real Results
        </Typography>
      </LandingPageSection>
      <SplitScreenBlock
        className="territories-split-screen-block"
        backgroundImage
        image={split1Image}
        title="The Formula"
        list={[
          "Target Households",
          "Conversion Funnel",
          "Project Estimates",
          "Divided by 5 = Max Designers",
        ]}
      />
      <SplitScreenBlock
        className="territories-split-screen-block"
        reverse
        backgroundImage
        image={split2Image}
        title="What This Means For You"
        list={[
          "Better Match Quality",
          "Less Competition",
          "Higher Close Rates",
          "Predictable ROI",
        ]}
      />

      <LandingPageSection>
        <Accordion
          items={[
            {
              title: "What’s a DMA and why do you use them?",
              description:
                "Designated market area (DMA), also referred to as a media market, is a region of the United States that is used to define television, radio markets. There are 210 DMAs covering the whole United States and are usually defined based on metropolitan areas, with suburbs often being combined within - powerful when used for located-based marketing such as ours. DMAs are determined by the Nielsen Company and impact the cost of advertising in a specific area. When we evaluate your territory’s marketing mix it is important that we understand the DMA and weigh the potential opportunities and costs.",
            },
            {
              title: "What is BETA mode?",
              description: `Beta Mode is when a territory is actively recruiting designers memberships and is not
yet live to homeowners.`,
            },
            {
              title: "Why do you limit the number of designers per territory? ",
              description: `Our main competitors do not limit the number of professionals they allow on their
platforms, diluting not only their members return on investment but also the quality of
their professional community. We exist to empower the designer community and limit
the number of designers by territory to ensure we deliver enough leads to the
community that returns their investment potential.`,
            },
            {
              title:
                "How do you limit the number of designers per territory?  ",
              description: `We use a proven marketing funnel conversion formula. The top of the funnel is filled
with the number of target households per territory which converts to the very bottom
of the funnel based on number of jobs we believe we can deliver. The total number of
jobs is divided by 5 and that outputs our maximum number of designers in that
territory. Important to note that we only deliver matched leads to each designer which
is higher in the funnel than jobs, however we feel that your return will be based on
profit from the leads you close and ultimately turn into jobs. Therefore the number of
designers per territory is calculated based on potential jobs.`,
            },
            {
              title: "What if I do business in more then one territory?",
              description: `(1) one territory is included in your membership package. Additional territories can be
added for a fee of $4,000 each.`,
            },
            {
              title: "What if I don’t cover my entire territory?",
              description: `Your membership will cover the entire territory, you may choose to opt out of client
matches based on job location within your territory.`,
            },
          ]}
        />
      </LandingPageSection>

      <LandingPageSection className="footer-section pink-section text-center">
        <Typography
          variant="h4"
          className="text-center font-body title"
          sx={{ mb: "20px" }}
        >
          {" "}
          READY TO CLAIM YOUR SPOT?
        </Typography>
        <Typography
          variant="body1"
          className="text-center contain-text section-subtitle font-size-4"
          sx={{
            mb: "28px",
          }}
        >
          Lock in Your Territory Before It Fills Up
        </Typography>

        <Button
          component={Link}
          variant="contained"
          size="large"
          to={Pages.SIGNUP}
          color={"white" as any}
          className="font-size-4"
        >
          Apply Now
        </Button>
      </LandingPageSection>
    </div>
  );
};
